import type { AlertServiceAnalyticsEvent } from '@/scopes/prices/domain/analytics'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { useMutation } from '@tanstack/react-query'
import defaultFetch from 'isomorphic-unfetch'

export function useAlertService(contextItemId: string, alertServiceDataSourceId?: string, accommodationId?: number) {
  const { sendEvent } = useAnalytics()

  const {
    mutate,
    isPending: isLoading,
    isError,
    isSuccess,
    reset,
    data,
  } = useMutation({
    mutationFn: async (email: string) => {
      const response = await defaultFetch(
        `${process.env.NEXT_PUBLIC_API_BASE_URL}/PriceAlert/CreateAlertSubscription?contextitemid=${contextItemId}`,
        {
          method: 'POST',
          body: JSON.stringify({
            datasourceId: alertServiceDataSourceId,
            email,
            itemId: contextItemId,
            accommodationId,
          }),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        },
      )
      if (!response.ok) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject()
      }
      return response.json()
    },
    onSuccess: () => {
      sendEvent({
        event: 'Next Season Alert',
        description: 'Alert Service',
        type: 'Next Season',
        result: 'Signup',
        eventValue: 1,
      } as AlertServiceAnalyticsEvent) // TODO: Should we keep using AlertServiceAnalyticsEvent from Prices scope ??
    },
  })

  return {
    mutate,
    isLoading,
    isError,
    isSuccess,
    reset,
    data,
  }
}
